module.exports = __webpack_public_path__ + "language-switcher-01ac634c/illustration-right-fb9220eec10a411dd5cceada5dfbba57.svg";